import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import WidgetHeader from '../Widget/WidgetHeader';
import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';

import AddressPopup from '../../components/FindPollingStation/AddressPopup';
import AnswerButton from '../../components/Assessment/AnswerButton';
import CssTransition from '../../components/Transition/CssTransition';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import ShareDrawer from '../../components/ShareDrawer';
import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import { Container, RockTheVoteLabel } from '../DefaultStyles/Details';
import {
    Body,
    Title,
    Content,
    Description,
    DetailsContainer,
    Details,
    Footer
} from '../DefaultStyles/Shared';

import { onShowAddressPopup } from './actions';
import { setOverlayPartnerVisible } from '../Widget/actions';

import { isLongText } from '../../components/Shared/commonFunctions';

import rockTheVoteLogo from '../../assets/images/rock-the-vote-logo.png';
import { RockTheVoteDetails } from '../../components/Shared/rockTheVoteDetails';

const FindPollingStationDetails = props => (
    <Container>
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner
            transitionType="right-to-left"
            logo={rockTheVoteLogo}
            name={props.rockTheVoteTitle}
            description={props.rockTheVoteDescription}
        />
        <Body>
            <WidgetHeader />
            <Content isContactAction={false} isSingleAction={true}>
                <Title
                    isLongText={isLongText(props.title, 60)}
                    isExtraLongText={isLongText(props.title, 95)}
                    onClick={e => props.setOverlayPartnerVisible(true, e, false)}
                    dangerouslySetInnerHTML={{
                        __html: props.title
                    }}
                />
                <DetailsContainer>
                    <Details>
                        <Description
                            onClick={e => props.setOverlayPartnerVisible(true, e, false)}
                            isLongText={isLongText(props.subTitle, 90)}
                            isExtraLongText={isLongText(props.subTitle, 160)}
                            dangerouslySetInnerHTML={{
                                __html: props.subTitle
                            }}
                        />
                        <RockTheVoteLabel
                            onClick={e => props.setOverlayPartnerVisible(true, e, true)}
                        >
                            {props.rockTheVoteLabel}
                        </RockTheVoteLabel>
                    </Details>
                </DetailsContainer>
            </Content>
            <AutoScalingButtonSet mobileStyled={true} mobileLeftPosition={8}>
                <AnswerButton
                    text={props.registerButtonText}
                    useLoadingSpinner={false}
                    onClick={() => {
                        props.onShowAddressPopup(true, props.actionIdentifier);
                    }}
                />
            </AutoScalingButtonSet>
            <Footer>
                <ShareDrawer backgroundColor={'#fff'} />
            </Footer>
            <TransitionGroup>
                {props.showAddressPopup && (
                    <CssTransition key="alert" in={props.showAddressPopup}>
                        <AddressPopup
                            onBack={() => {
                                props.onShowAddressPopup(false, props.actionIdentifier);
                            }}
                        />
                    </CssTransition>
                )}
            </TransitionGroup>
            <TransitionGroup>
                {props.findPollingStationError && (
                    <CssTransition key="alert" in={props.findPollingStationError}>
                        <ToasterAlert content={props.findPollingStationError} />
                    </CssTransition>
                )}
            </TransitionGroup>
        </Body>
    </Container>
);

FindPollingStationDetails.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    actionIdentifier: PropTypes.string.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    rockTheVoteTitle: PropTypes.string,
    rockTheVoteDescription: PropTypes.string,
    registerButtonText: PropTypes.string.isRequired,
    rockTheVoteLabel: PropTypes.string.isRequired,
    showAddressPopup: PropTypes.bool,
    onShowAddressPopup: PropTypes.func.isRequired,
    findPollingStationError: PropTypes.string
};

export default connect(
    state => {
        const defaultTitle =
            'Voting is one of the most powerful tools we have. Make sure you know when and where to vote on Election Day to make your voice heard.';
        const defaultSubtitle =
            'Click below to find your polling station so you can be ready.';
        const defaultButton = 'Find';

        return {
            title: state.widget.activeAction.title || defaultTitle,
            subTitle: state.widget.activeAction.text || defaultSubtitle,
            actionIdentifier: state.widget.activeAction.identifier,
            rockTheVoteTitle: RockTheVoteDetails.title,
            rockTheVoteDescription: RockTheVoteDetails.description,
            rockTheVoteLabel: RockTheVoteDetails.label,
            registerButtonText:
                state.widget.activeAction.customButtonText || defaultButton,
            showAddressPopup: state.findPollingStation.showAddressPopup,
            findPollingStationError: state.findPollingStation.findPollingStationError
        };
    },
    {
        setOverlayPartnerVisible,
        onShowAddressPopup
    }
)(FindPollingStationDetails);



// WEBPACK FOOTER //
// ./src/containers/FindPollingStation/FindPollingStationDetails.jsx